
const LABELS = {
  customer_only: { text: "Payment only", color: "var(--amber-700, #b45309)", bg: "var(--amber-100, #fef3c7)" },
  rtk_active: { text: "RTK active", color: "var(--green-700, #15803d)", bg: "var(--green-100, #dcfce7)" },
  portal_user: { text: "CORS user", color: "var(--blue-700)", bg: "var(--blue-100)" },
};

export default function AccountTypeTag({ type }) {
  const cfg = LABELS[type];
  if (!cfg) return null;
  return (
    <span
      style={{
        fontSize: 10.5,
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: 999,
        color: cfg.color,
        background: cfg.bg,
        whiteSpace: "nowrap",
      }}
    >
      {cfg.text}
    </span>
  );
}